import React from 'react';

import Homepage from './pages/homepage';
import Product from './pages/product';
import Order from './pages/order';
import Supplier from './pages/supplier';
import Login from './pages/auth/login';
import Payment from './pages/payment';
import Profile from './pages/profile';
import Verification from './pages/auth/verification';
import Support from './pages/support';
import ForgotPassword from './pages/auth/forgot-password';
import ResetPasswordPage from './pages/auth/reset-password';
import VerifyEmailPage from './pages/auth/verify-email';
import ResendVerifyEmailPage from './pages/auth/resend-verify-email';
import Privacy from './pages/privacy';
import CorporateOrder from './pages/corporate-order';
import Faq from './pages/faq/faq';
import Terms from './pages/terms';
import Register from './pages/auth/register';
import VoucherDealsPage from './pages/voucher-deals';
import EPrescription from './pages/e-prescription';


// import {default as ProductCatalogPage} from "./pages/product/product-catalog";
// import Category from 'Components/shared/category';

const Test: React.FC<{ context: string }> = ({ context }) => {
  return <div>{context}</div>
}

const publicRoutes = [
  {
    path: '/',
    exact: true,
    component: <Homepage />,
    withLayout: true,
    isActive: true,
  },
  {
    path: '/login',
    exact: true,
    component: <Login />,
    isActive: true,
  },
  {
    path: '/privacy',
    exact: true,
    component: <Privacy />,
    isActive: true,
  },
  {
    path: '/terms',
    exact: true,
    component: <Terms />,
    isActive: true,
  },
  {
    path: '/register',
    exact: true,
    component: <Register accountType='INDIVIDUAL_ACCOUNT'/>,
    isActive: true,
  },
  {
    path: '/register-business-account',
    exact: true,
    component: <Register accountType='BUSINESS_ACCOUNT'/>,
    isActive: true,
  },
  {
    path: '/corporate',
    exact: true,
    component: <CorporateOrder />,
    withLayout: true,
    isActive: true,
  },
  {
    path: '/products/:id',
    exact: true,
    component: <Product.ProductDetailsPage />,
    withLayout: true,
    isActive: true,
  },
  {
    path: '/payment/submit',
    exact: true,
    component: <Payment.PaymentPrebuiltPage />,
    withLayout: false,
    isActive: true,
  },
  {
    path: '/order/status',
    exact: true,
    component: <Order.OrderPaymentStatusPage />,
    withLayout: true,
    isActive: true,
  },
  {
    path: '/support',
    exact: true,
    component: <Support />,
    withLayout: true,
    isActive: true
  },
  {
    path: '/faq',
    exact: true,
    component: <Faq/>,
    withLayout: true,
    isActive: true
  },
  {
    path: '/forget-password',
    exact: true,
    component: <ForgotPassword/>,
    isActive: true
  },
  {
    path: '/reset-password',
    exact: true,
    component: <ResetPasswordPage />,
    isActive: true,
  },
  {
    path: '/resend-verify-email',
    exact: true,
    component: <ResendVerifyEmailPage />,
    isActive: true,
  },
  {
    path: '/verify-email',
    exact: true,
    component: <VerifyEmailPage />,
    isActive: true,
  },
  /*{
    path: '/products/supplier/:id',
    exact: true,
    component: <Product.ProductSupplierPage/>,
    withLayout: true,
    isActive: true
  },*/
  {
    path: '/products/catalog/list',
    exact: true,
    component: <Product.ProductCatalogPage/>,
    withLayout: true,
    isActive: true
  },
  {
    path: '/supplier/:id',
    exact: true,
    component: <Supplier.Homepage />,
    withLayout: true,
    isActive: true
  },
  {
    path: '/deals',
    exact: true,
    component: <VoucherDealsPage />,
    withLayout: true,
    isActive: true
  },
  {
    path: '/deals/:id',
    exact: true,
    component: <VoucherDealsPage />,
    withLayout: true,
    isActive: true
  }
];

const protectedRoutes = [
  {
    path: '/cart',
    exact: true,
    component: <Product.ProductCartPage />,
    isActive: true,
  },
  {
    path: '/checkout',
    exact: true,
    component: <Product.ProductCheckoutPage />,
    isActive: true,
  },
  {
    path: '/purchase',
    exact: true,
    component: <Order.PurchaseList />,
    isActive: true,
  },
  {
    path: '/purchase/:id',
    exact: true,
    component: <Order.OrderDetails />,
    withLayout: true,
    isActive: true,
  },
  {
    path: '/voucher-listing/:id',
    exact: true,
    component: <Order.VoucherListPage />,
    isActive: true,
  },
  {
    path: '/verification',
    exact: true,
    component: <Verification />,
    isActive: true
  },
  {
    path: '/e-prescription/upload',
    exact: true,
    component: <EPrescription.UploadEPrescription />,
    withLayout: true,
    isActive: true
  },
  {
    path: '/profile',
    exact: true,
    component: <Profile.ProfileDetailsPage />,
    isActive: true,
  },
  {
    path: '/proceed',
    exact: true,
    component: <Product.ProductProceedPage/>,
    withLayout: true,
    isActive: true
  }
];

const routes = {
  public: publicRoutes,
  protected: protectedRoutes,
}

export default routes;
